import { type AtlasGqlBladeMakeModel } from 'types/atlas-graphql';

export const hasSingleValidBladeMakeModel = (
  makeModels: AtlasGqlBladeMakeModel[] | null | undefined
) => makeModels?.length === 1 && makeModels[0].make && makeModels[0].model && makeModels[0].length;
